import classNames from 'classnames';
import { useViewport } from '@farmersdog/corgi-x';
import { Chevron } from '@farmersdog/corgi-x/icons';
import { useShowHomepageRedesign } from 'src/hooks/useHomepageRedesign';
import { ChevronScribbleDesktop, ChevronScribbleMobile } from '../assets';

import styles from './ChevronButton.module.css';

interface ChevronButtonProps {
  orientation?: 'left' | 'right';
  onClick: () => void;
  ariaLabel: string;
}

export const ChevronButton = ({
  orientation = 'left',
  onClick,
  ariaLabel,
}: ChevronButtonProps) => {
  const viewport = useViewport();
  const isMobile = !viewport.md;
  const { isOlsTreatment, isOlsVetsTreatment, isOlsHealthTreatment } =
    useShowHomepageRedesign();

  return (
    <button
      onClick={onClick}
      className={styles.chevronButton}
      aria-label={ariaLabel}
      tabIndex={0}
    >
      <div
        className={classNames(styles.chevron, {
          [styles.chevronOlsVets]: isOlsVetsTreatment,
          [styles.chevronOlsHealth]: isOlsHealthTreatment,
          [styles.orientationLeft]: orientation === 'left',
        })}
      >
        {isOlsTreatment ? (
          <Chevron size={isMobile ? 36 : 72} />
        ) : isMobile ? (
          <ChevronScribbleMobile />
        ) : (
          <ChevronScribbleDesktop />
        )}
      </div>
    </button>
  );
};
